export default {
      id: "i-cart-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "img/sprite.svg#i-cart",
      toString: function () {
        return this.url;
      }
    }